import React from 'react';
import { Helmet } from 'react-helmet-async'; // Import Helmet
import './ServicesPage.css'; // Create this CSS file for styling

interface ServiceDetail {
    id: string;
    title: string;
    description: string;
    subActivities: string[];
    iconClass?: string; // Optional: For adding icons later
}

const servicesData: ServiceDetail[] = [
    {
        id: 'process-mapping',
        title: 'Process Mapping & Optimisation',
        description: 'Visualising, analysing, and improving your business workflows to enhance efficiency, reduce costs, and ensure consistency.',
        subActivities: [
            'Current State ("As-Is") Process Mapping Workshops',
            'Workflow Analysis & Bottleneck Identification',
            'Future State ("To-Be") Process Design',
            'Standard Operating Procedure (SOP) Development',
            'Process Standardisation & Documentation',
            'Identifying Automation Opportunities',
            '5 Why Root Cause Analysis',
        ],
        iconClass: 'fas fa-project-diagram', // Example Font Awesome icon
    },
    {
        id: 'custom-reporting',
        title: 'Custom Reporting & Data Insights',
        description: 'Transforming raw data into actionable insights through bespoke reporting solutions, dashboards, and data analysis.',
        subActivities: [
            'Business Intelligence (BI) Dashboard Development (e.g., Power BI)',
            'Management Information (MI) Report Creation',
            'SQL Data Extraction, Transformation, and Loading (ETL)',
            'Data Source Identification & Validation',
            'Performance Monitoring & KPI Tracking Solutions',
            'Reporting Automation',
        ],
        iconClass: 'fas fa-chart-bar', // Example Font Awesome icon
    },
    {
        id: 'operations-launch',
        title: 'Operations Launch & Transition Management',
        description: 'Successfully launching new operational processes, systems, or platforms, ensuring smooth transitions and user adoption.',
        subActivities: [
            'Project Management for Operational Rollouts (e.g., Prince2 / APM)',
            'System Implementation Support (e.g. Kit Procurement, Contact Centre Platform Setup)',
            'User Acceptance Testing (UAT) - Ownership / Coordination',
            'Development of Training Materials & Delivery',
            'Change Management & Communication Planning',
            'Customer / User Migration Strategy & Execution',
        ],
        iconClass: 'fas fa-rocket', // Example Font Awesome icon
    },
    {
        id: 'tech-creation',
        title: 'Bespoke Tool & Solution Development',
        description: 'Creating custom technical solutions, often leveraging existing platforms, to solve specific business problems or automate tasks.',
        subActivities: [
            'Requirements Gathering & Specification Documentation',
            'Excel VBA Macro Development / Power App Flows for Automation',
            'Development of Custom Tracking & Management Tools',
            'Liaison Between Business Stakeholders & Development Teams',
            'Solution Design & Prototyping',
            'Testing & User Feedback Integration',
        ],
        iconClass: 'fas fa-cogs', // Example Font Awesome icon
    },
];

const ServicesPage: React.FC = () => {
    return (
        <div className="services-page container">
            <Helmet>
                <title>Our Services | Process Mapping, Reporting, Ops Launch | IntelPro</title>
                <meta name="description" content="Explore IntelPro's services: Process Mapping & Optimisation, Custom Reporting & Data Insights, Operations Launch & Transition, Bespoke Tool Development." />
            </Helmet>
            <h1>Our Services</h1>
            <p className="page-intro">
                We help businesses optimise their operations, gain valuable insights from data, launch new initiatives smoothly, and create targeted technical solutions. Explore our core service areas below:
            </p>

            <div className="services-grid">
                {servicesData.map((service) => (
                    <div key={service.id} className="service-card">
                        {service.iconClass && <i className={`${service.iconClass} service-icon`}></i>}
                        <h2>{service.title}</h2>
                        <p>{service.description}</p>
                        <h3>Key Activities Include:</h3>
                        <ul>
                            {service.subActivities.map((activity, index) => (
                                <li key={index}>{activity}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServicesPage;
